import React, { Suspense, lazy } from 'react';

const Loadable = (Component) => (props) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <Suspense fallback={<></>}>
    <Component {...props} />
  </Suspense>
);

export function lazyWithPreload(
  factory,
) {
  const Component = lazy(factory);
  Component.preload = factory;
  return Component;
}

export default Loadable;
